export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11368.bc78659d.jpg";